import 'core-js/es/reflect';
import 'core-js/es/array';
import 'core-js/es/map';
import 'core-js/es/object';
import 'core-js/es/set';
import 'hammerjs';
import 'url-polyfill';
import 'zone.js';

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
* BROWSER POLYFILLS
*/

// Smooth material components interactions
/** IE10 and IE11 requires the following for NgClass support on SVG elements */
/** IE10 and IE11 requires the following for the Reflect API. */
/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
/**
 * Required to support Web Animations `@angular/platform-browser/animations`.
 * Needed for: All but Chrome, Firefox and Opera. http://caniuse.com/#feat=web-animation
 **/
// polyfill for url api
/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
/***************************************************************************************************
 * APPLICATION IMPORTS
 */


if (!Object.entries) {
  Object.entries = function (obj): any[] {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i); // preallocate the Array
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];

      return resArray;
    }
  };
}

(window as any).global = window;


if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype['msMatchesSelector'] || Element.prototype['webkitMatchesSelector'];
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    let el = this;

    do {
      if (Element.prototype.matches.call(el, s)) { return el; }
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
